/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDate } from '@js-joda/core';

export enum RelationshipType {
    Partner = 'partner',
    Spouse = 'spouse',
    Child = 'child',
    Parent = 'parent',
    Sibling = 'sibling',
    Other = 'other',
    Self = 'self'
}

export class PersonModel {
    personUid?: string;
    userUid?: string;
    relationship: RelationshipType;
    nickname: string;
    dob: LocalDate;
    isDependent: boolean;
    photo?: Blob;
    photos?: any[];
}
